import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Box, Tabs, Tab } from '@mui/material'
import { useEffect, useRef } from 'react'

export const Navigation = ({ navInfo }) => {  
    const {home, projects, skills, experience} = navInfo;
    const location = useLocation();
    const navigate = useNavigate();
    const navigationRef = useRef(null);

    const getTabValue = () => {
        if (location.pathname === '/projects') return 1;
        if (location.pathname === '/skills') return 2;
        if (location.pathname === '/experience') return 3;
        return 0;
    };

    const handleChange = (event, newValue) => {
        const paths = ['/', '/projects', '/skills', '/experience'];
        navigate(paths[newValue]);
    };

    // Scroll to content area when navigating to projects/skills/experience
    // Scroll to top when navigating to home
    useEffect(() => {
        if (location.pathname === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // Small delay to ensure content is rendered
            setTimeout(() => {
                if (navigationRef.current) {
                    const elementTop = navigationRef.current.getBoundingClientRect().top + window.pageYOffset;
                    // Scroll to show tabs with a small offset for better visibility
                    window.scrollTo({ 
                        top: elementTop - 60, 
                        behavior: 'smooth' 
                    });
                }
            }, 100);
        }
    }, [location.pathname]);

    return (
      <Box ref={navigationRef} sx={navigationContainerStyles}>
        <Box sx={tabsWrapperStyles}>
          <Tabs 
            value={getTabValue()} 
            onChange={handleChange}
            variant="fullWidth"
            sx={{
              minHeight: '45px',
              '& .MuiTabs-flexContainer': {
                borderBottom: '1px solid #e1e8ed',
              },
              '& .MuiTab-root': {
                color: '#657786',
                fontWeight: 700,
                fontSize: '15px',
                textTransform: 'none',
                minHeight: '45px',
                padding: '8px 12px',
                borderTopLeftRadius: '12px',
                borderTopRightRadius: '12px',
                marginRight: '2px',
                backgroundColor: '#f7f9fa',
                border: '1px solid #e1e8ed',
                borderBottom: 'none',
                position: 'relative',
                zIndex: 1,
                transition: 'all 0.2s',
                '&:hover': {
                  backgroundColor: '#eff3f4',
                },
                '&.Mui-selected': {
                  color: '#0f1419',
                  backgroundColor: '#fff',
                  borderBottom: '1px solid #fff',
                  zIndex: 2,
                  marginBottom: '-1px',
                },
              },
              '& .MuiTabs-indicator': {
                display: 'none',
              },
            }}
          >
              <Tab label={home} />
              <Tab label={projects} />
              <Tab label={skills} />
              <Tab label={experience} />
          </Tabs>
        </Box>
        <Box sx={tabsContentStyles}>
          <Outlet key={location.pathname} />
        </Box>
      </Box>
    )
  }

const navigationContainerStyles = {
  fontSize: '15px',
  position: 'relative',
  marginTop: 0,
  paddingTop: 0,
  '@media (max-width: 768px)': {
    fontSize: '14px',
  },
};

const tabsWrapperStyles = {
  position: 'relative',
  zIndex: 1,
};

const tabsContentStyles = {
  position: 'relative',
  zIndex: 0,
  '& > *': {
    animation: 'fadeIn 0.3s ease-in-out',
  },
};
